<template>
  <div>
    <common-dialog
      ref="dialog"
      width="610px"
      edit-title
      unit="学生纪律量化登记"
      id-key="DisciplineRecordId"
      :data="data"
      form-label-width="42px"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      @create-opened="onCreateOpened"
      :before-save="onBeforeSave"
      @close-saved="$emit('close-saved')"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB?24:9">
            <el-form-item label="姓名" :class="{ 'MBForm': isMB }">
              <el-input size="mini" v-model="params.FullName" placeholder="请填写姓名" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:10" class="sn-label">
            <el-form-item label="学生编号" :class="{ 'MBForm': isMB }">
              <el-input size="mini" v-model="params.StudentNumber" placeholder="请填写学生编号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:5">
            <el-button icon="el-icon-search" type="primary" :style="isMB?'margin:0 0 8px 0px;':'margin-left: 15px;'" style="padding:6px 15px;" @click="search">快速定位</el-button>
          </el-col>
        </el-row>
        <el-row v-if="mainData.length">
          <el-col :span="24">
            <div class="addr_box m-scroll">
              <div class="addr_item" @click="addrClick(item,index)" :class="{ 'item_active': item.active }" v-for="(item,index) in mainData" 
              :key="index" :style="index==mainData.length-1?'border-right-width:1px;':''">{{item.Addr}}栋</div>
            </div>
            <div class="floor_box m-scroll">
              <div class="floor_item" @click="floorClick(item2,index2)" :class="{ 'item_active': item2.active }" v-for="(item2,index2) in floorData" 
              :key="index2" :style="index2==floorData.length-1?'border-right-width:1px;':''">{{item2.Floor}}层</div>
            </div>
            <div class="dorm_box m-scroll">
              <div class="dorm_item" @click="dormClick(item3,index3)" :class="{ 'item_active': item3.active }" v-for="(item3,index3) in dormData" 
              :key="index3" :style="index3==dormData.length-1?'border-right-width:1px;':''">{{item3.Number}}</div>
            </div>
            <div class="st_py_box">
              <div class="st_box">
                <div class="st_item" :class="{ 'selected': selected(item4.StudentId) }" @click="setSt(item4)"
                v-for="item4 in stData" :key="item4.StudentId" :title="item4.StudentNumber">{{item4.FullName}}</div>
              </div>
              <div class="py_box" v-if="stData.length">
                <div class="py_item" :class="{ 'selected': activeWord=='全' }" @click="wordClick('全')">全</div>
                <div class="py_item" :class="{ 'selected': activeWord==item4 }" v-for="item4 in pyList" :key="item4" @click="wordClick(item4)">{{item4}}</div>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row v-if="set_data.length">
          <el-col :span="24">
            <div class="m-scroll" style="max-height:55vh;overflow-Y:auto;">
              <div class="set_box" v-for="(item,index) in set_data" :key="item.StduentId" :style="index==set_data.length-1?'margin-bottom:0;':''">
                <div class="name">
                  <span>{{item.FullName}}</span>
                  <div>
                    <el-button type="success" style="float:rigth;" v-if="index" @click="same(item,index)">同上</el-button>
                    <i class="el-icon-close" @click="removeSt(index)"></i>
                  </div>
                </div>
                <el-row>
                  <el-col :span="24">
                    <el-button type="primary" plain @click="plus15(item,-1)">-15min</el-button>
                    <el-date-picker type="datetime" v-model="item.RecordTime" placeholder="请选择日期" format="yyyy-MM-dd HH:mm" 
                    value-format="yyyy-MM-dd HH:mm:ss" :class="{ 'MBDatepicker': isMB }" @change="getPoint(item)" />
                    <el-button type="primary" plain @click="plus15(item,1)">+15min</el-button>
                  </el-col>
                  <el-col :span="9" style="margin: 5px 0;">
                    <!-- <tree-select
                      :ref="'treeSelect'+index"
                      style="width:100%;"
                      :props="props"
                      :options="TreeData"
                      :value="item.DisciplineTypeId"
                      :clearable="true"
                      :accordion="true"
                      :parentSelect="false"
                      placeholder="请选择扣分类别"
                      @node-select="onTreeSelect($event,item)"
                    /> -->
                    <el-select v-model="item.Pid" v-if="refresh" @change="pChange(item)" style="width:100%;" :placeholder="isMB?'一级类别':'请选择一级类别'">
                      <el-option v-for="p in plist" :key="p.DisciplineTypeId" :value="p.DisciplineTypeId" :label="p.DisciplineTypeName" />
                    </el-select>
                  </el-col>
                  <el-col :span="9" style="margin: 5px 0;">
                    <el-select v-model="item.DisciplineTypeId" @change="disChange(item)" style="width:100%;" :placeholder="isMB?'二级类别':'请选择二级类别'">
                      <el-option v-for="s in item.slist" :key="s.DisciplineTypeId" :value="s.DisciplineTypeId" :label="s.DisciplineTypeName" />
                    </el-select>
                  </el-col>
                  <el-col :span="6" style="margin: 5px 0;">
                    <el-input type="number" v-model="item.Point" @blur="checkNum(item)" :placeholder="isMB?'扣分值':'请填写扣分值'"></el-input>
                  </el-col>
                  <el-col :span="24" style="margin-bottom: 5px;">
                    <el-input v-model="item.Remark" placeholder="请填写备注"></el-input>
                  </el-col>
                  <el-col :span="24">
                    <import-file
                      :upload-url="api.UploadFileUrl"
                      :subData="{}"
                      text="上传附件"
                      w="80px"
                      :btntype="true"
                      single
                      @on-uploaded="uploaded($event,item)"
                      @on-remove="removed($event,item)"
                      :uploadFiles="item.uploadedFiles"
                    />
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-col>
        </el-row>
      </template>
      <template slot="footer">
        <span style="float:left;line-height:38px;">扣分人：{{loginInfo.UserName}}</span>
        <el-button type="primary" @click="toSave(1)">保 存</el-button>
        <el-button type="success" @click="toSave(2)">保存并继续</el-button>
        <el-button @click="close(true)">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));

import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
// import treeSelect from "@/components/common/treeSelect";
import importFile from "@/components/common/files/importFile";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    // treeSelect,
    importFile
  },
  data() {
    return {
      api: require("@/api/attendance/disrecord").default,
      strApi: require("@/api/attendance/strict").default,
      disApi: require("@/api/attendance/disciplinetype").default,
      data: {},
      mainData: [],
      floorData: [],
      dormData: [],
      stData: [],
      pyList: [],
      set_data: [],
      // props: {
      //   value: "DisciplineTypeId",
      //   label: "DisciplineTypeName",
      //   children: "children",
      // },
      // TreeData: [],
      params: {
        TermId: 0,
        FullName: "",
        StudentNumber: ""
      },
      disList: [],
      plist: [],
      refresh: true,
      loginInfo,
      keep: 0,
      isMB: this.$store.state.isMB,
      rules: {
        
      },
    };
  },
  methods: {
    onCreateOpened() {
      this.params.TermId = localStorage.getItem("quaTerm");
      this.getData();
      this.disApi.list({ Status: 1 }).then(res => {
        this.disList = res.Data;
        this.plist = res.Data.filter(x => x.Lv == 1);
        // this.TreeData = this.$commonJs.toTreeData(res.Data, "DisciplineTypeId");
      });
    },
    getData() {
      this.api.getAddrs({ TermId: this.params.TermId }).then(res => {
        if(res.Code==0) {
          res.Data.forEach((e,index) => {
            e.Floors.forEach(p => {
              p.Dormitorys.forEach(n => {
                n.Students = n.Students.map(x => { return { ...x, DisciplineTypeId: null, DisciplineTypeName: "", StrictControlId: 0, 
                  Point: "", RecordTime: "", Remark: "", FileUrl: "", uploadedFiles: [] } })
              })
            })
            if(index==0) {
              e.active = true;
              e.Floors[0].active = true;
              e.Floors[0].Dormitorys[0].active = true;
              this.floorData = e.Floors;
              this.dormData = e.Floors[0].Dormitorys;
              this.stData = e.Floors[0].Dormitorys[0].Students;
              this.setPy();
            }
          })
          this.mainData = res.Data;
        } else {
          this.$message.error(res.Msg);
        }
      })
    },
    // onTreeSelect(t,item) {
    //   if(t) {
    //     item.DisciplineTypeId = t.DisciplineTypeId;
    //     item.DisciplineTypeName = t.DisciplineTypeName;
    //     item.Point = t.Point;
    //     this.getPoint(item);
    //   } else {
    //     item.DisciplineTypeId = 0;
    //     item.DisciplineTypeName = "";
    //   }
    // },
    getPoint(item) {
      if(item.RecordTime && item.DisciplineTypeId) {
        this.strApi.getPoint({ disciplineTypeId: item.DisciplineTypeId, time: item.RecordTime }).then(res => {
          if(res.Code==0) {
            item.Point = res.Data;
          }
        })
      }
    },
    addrClick(item,index) {
      if(item.active) return;
      this.mainData.forEach((e,i) => {
        e.active = i==index;
      })
      item.Floors.forEach((e,i) => {
        e.active = i==0;
      })
      item.Floors[0].Dormitorys.forEach((e,i) => {
        e.active = i==0;
      })
      this.floorData = item.Floors;
      this.dormData = item.Floors[0].Dormitorys;
      this.stData = item.Floors[0].Dormitorys[0].Students;
      this.setPy();
    },
    floorClick(item,index) {
      if(item.active) return;
      this.floorData.forEach((e,i) => {
        e.active = i==index;
      })
      item.Dormitorys.forEach((e,i) => {
        e.active = i==0;
      })
      this.dormData = item.Dormitorys;
      this.stData = item.Dormitorys[0].Students;
      this.setPy();
    },
    dormClick(item,index) {
      if(item.active) return;
      this.dormData.forEach((e,i) => {
        e.active = i==index;
      })
      this.stData = item.Students;
      this.setPy();
    },
    selected(id) {
      return (this.set_data.findIndex(x => x.StudentId == id)) > -1;
    },
    pChange(item) {
      item.DisciplineTypeId = null;
      item.DisciplineTypeName = "";
      item.slist = this.disList.filter(x => x.Pid == item.Pid);
      this.refresh = false;
      this.$nextTick(() => {
        this.refresh = true;
      })
    },
    disChange(item) {
      var obj = item.slist.find(x => x.DisciplineTypeId == item.DisciplineTypeId);
      item.DisciplineTypeName = obj.DisciplineTypeName;
      this.getPoint(item);
    },
    checkNum(item) {
      if(item.Point > 0) {
        item.Point = Number(item.Point);
      } else {
        item.Point = null;
      }
    },
    search() {
      var name = this.params.FullName;
      var no = this.params.StudentNumber;
      if(!name && !no) {
        this.$message.warning("请填写姓名或者学生编号");
        return;
      }
      var has = false;
      for (let i = 0; i < this.stData.length; i++) {
        const e = this.stData[i];
        if(e.FullName.indexOf(name) > -1 && e.StudentNumber.indexOf(no) > -1) {
          this.setSt(e);
          has = true;
          break;
        }
      }
      // for (let i = 0; i < this.mainData.length; i++) {
      //   const e = this.mainData[i];
      //   for (let j = 0; j < e.Floors.length; j++) {
      //     const n = e.Floors[j];
      //     for (let k = 0; k < n.Dormitorys.length; k++) {
      //       const p = n.Dormitorys[k];
      //       for (let l = 0; l < p.Students.length; l++) {
      //         const m = p.Students[l];
      //         if(m.FullName.indexOf(name) > -1 && m.StudentNumber.indexOf(no) > -1) {
      //           if(this.set_data.findIndex(x => x.StudentId==m.StudentId) == -1) this.setSt(m);
      //           this.floorData = e.Floors;
      //           this.dormData = n.Dormitorys;
      //           this.stData = p.Students;
      //           this.setPy();
      //           this.mainData.forEach((d,q) => {
      //             d.active = q==i;
      //           })
      //           this.floorData.forEach((f,w) => {
      //             f.active = w==j;
      //           })
      //           this.dormData.forEach((g,y) => {
      //             g.active = y==k;
      //           })
      //           has = true;
      //           return;
      //         }
      //       }
      //     }
      //   }
      // }
      if(!has) {
        this.$message.warning("没有符合条件的结果");
      }
    },
    same(item,index) {
      var pre = this.set_data[index-1];
      item.RecordTime = pre.RecordTime;
      item.Point = pre.Point;
      item.Remark = pre.Remark;
      item.Pid = pre.Pid;
      item.slist = pre.slist||[];
      item.DisciplineTypeId = pre.DisciplineTypeId;
      item.DisciplineTypeName = pre.DisciplineTypeName;
      item.FileUrl = pre.FileUrl;
      item.uploadedFiles = pre.uploadedFiles;
      // console.log(pre.uploadedFiles,item.uploadedFiles)
      // if(pre.DisciplineTypeId) {
      //   this.$refs['treeSelect'+index][0].setData(pre.DisciplineTypeId);
      // } else {
      //   this.$refs['treeSelect'+index][0].clearHandle();
      // }
    },
    setSt(item) {
      var obj = this.set_data.find(x => x.StudentId == item.StudentId);
      if(!obj) {
        var obj2 = this.plist.find(x => x.DisciplineTypeName == "宿舍区-卫生");
        item.Pid = obj2?obj2.DisciplineTypeId:null;
        if(item.Pid) {
          item.slist = this.disList.filter(x => item.Pid==x.Pid);
        } else {
          item.slist = [];
        }
        item.RecordTime = this.$commonJs.getNowDatetimeString();
        this.set_data.push(item);
        // if(item.DisciplineTypeId) {
        //   this.$nextTick(() => {
        //     this.$refs['treeSelect' + (this.set_data.length-1)][0].setData(item.DisciplineTypeId);
        //   })
        // }
      }
    },
    removeSt(index) {
      this.set_data.splice(index,1);
    },
    plus15(item,type) {
      if(!item.RecordTime) return;
      var time = (new Date(item.RecordTime)).getTime() + 900000*type;
      item.RecordTime = this.$commonJs.toDatetimeString(time);
      this.getPoint(item);
    },
    uploaded(res, item) {
      // item.FileName = res.Data.FileName + "." + res.Data.Extension;
      if(res.Data) {
        item.FileUrl = res.Data.VirtualPath;
        item.uploadedFiles = [{ name: res.Data.FileName+ "." +res.Data.Extension, url: '/api' + res.Data.VirtualPath }];
      }
    },
    removed(res, item) {
      item.FileUrl = "";
      item.uploadedFiles = [];
    },
    toSave(t) {
      this.keep = t;
      this.save();
    },
    onBeforeSave() {
      var inCom = [];
      if(!this.set_data.length) {
        this.$message.error("请选择要登记的学生");
        return false;
      }
      this.set_data.forEach(e => {
        if(!e.RecordTime || !e.Point || !e.DisciplineTypeId) {
          inCom.push(e.FullName);
        }
      })
      if(inCom.length) {
        this.$message.error("请完善登记数据：" + inCom.join(","));
        return false;
      }
      var sub = [];
      this.set_data.forEach(e => {
        sub.push({
           ...e,
           DisciplineRecordId: 0,
           TermId: this.params.TermId,
           AddTeacherId: loginInfo.UserId,
        })
      })
      console.log(sub);
      // return false;
      this.loading(true);
      this.api.saveList(sub).then(res => {
        this.loading(false);
        if(res.Code==0) {
          this.$message.success(res.Msg);
          if(this.keep == 1) {
            this.close(true);
            this.$emit('close-saved');
          } else {
            this.set_data = [];
          }
        } else {
          this.$message.error(res.Msg);
        }
      }).catch(() => {
        this.loading(false);
      })
      return false;
    },
    wordClick(word) {
      this.activeWord = word;
      var obj1 = this.mainData.find(x => Boolean(x.active));
      var obj2 = obj1.Floors.find(x => Boolean(x.active));
      var obj3 = obj2.Dormitorys.find(x => Boolean(x.active));
      if(word == "全") {
        this.stData = obj3.Students;
      } else {
        this.stData = obj3.Students.filter(x => this.spell(x.FullName) == word);
      }
    },
    setPy() {
      this.activeWord = "全";
      this.pyList = [];
      this.stData.forEach(e => {
        var word = this.spell(e.FullName);
        if(word && this.pyList.indexOf(word) == -1) {
          this.pyList.push(word);
        }
      })
    },
    spell(word) {
      if(word.spell()) {
        return word.spell()[0];
      } else {
        return "";
      }
    },
    onClosed() {
      this.mainData = [];
      this.floorData = [];
      this.stData = [];
      this.pyList = [];
      this.set_data = [];
      this.TreeData = [];
      this.plist = [];
      this.disList = [];
      this.activeWord = "全";
      this.params.FullName = "";
      this.params.StudentNumber = "";
      this.$emit('close-saved');
    },
  }
};
</script>
<style lang="scss">
.addr_box {
  width: 100%;
  overflow-x: auto;
  white-space: nowrap;
  .addr_item {
    display: inline-block;
    width: 14.28%;
    line-height: 30px;
    border: 1px solid #666;
    border-right-width: 0;
    text-align: center;
    cursor: pointer;
    @media screen and (max-width: 767px){
      width: 16.66%;
    }
  }
}
.floor_box {
  // display: flex;
  // flex-wrap: wrap;
  width: 100%;
  overflow-x: auto;
  margin-top: 5px;
  white-space: nowrap;
  .floor_item {
    display: inline-block;
    width: 14.28%;
    line-height: 30px;
    border: 1px solid #666;
    border-right-width: 0;
    text-align: center;
    cursor: pointer;
    @media screen and (max-width: 767px){
      width: 16.66%;
    }
  }
}
.dorm_box {
  width: 100%;
  overflow-x: auto;
  white-space: nowrap;
  margin-top: 5px;
  .dorm_item {
    display: inline-block;
    width: 70px;
    width: 14.28%;
    line-height: 30px;
    border: 1px solid #666;
    border-right-width: 0;
    text-align: center;
    cursor: pointer;
    @media screen and (max-width: 767px){
      width: 16.66%;
    }
  }
}
.st_py_box {
  border: 1px solid #666;
  margin: 5px 0;
}
.st_box {
  display: flex;
  flex-wrap: wrap;
  margin: 5px 0;
  .st_item {
    width: 14.28%;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
    @media screen and (max-width: 767px){
      width: 20%;
    }
    &:hover {
      color: #409eff;
    }
  }
  .selected {
    color: #f11;
    &:hover {
      color: #f11;
    }
  }
}
.py_box {
  display: flex;
  flex-wrap: wrap;
  .py_item {
    width: 30px;
    line-height: 25px;
    border: 1px solid #666;
    // border-width: 1px 1px 0 0;
    text-align: center;
    cursor: pointer;
    &:hover {
      color: #409eff;
    }
  }
  .selected {
    color: #f11;
    &:hover {
      color: #f11;
    }
  }
}
.item_active {
  background-color: #409eff;
  color: #fff;
}
.set_box {
  padding: 0px 10px 5px;
  margin-bottom: 5px;
  border: 1px solid #666;
  .name {
    display: flex;
    height: 40px;
    align-items: center;
    justify-content: space-between;
  }
  .el-icon-close {
    cursor: pointer;
    margin-left: 10px;
    &:hover {
      color: #409eff;
    }
  }
}
.MBForm {
  margin-bottom: 8px !important;
}
.sn-label {
  .el-form-item__label {
    width: 75px !important;
    @media screen and (max-width: 767px){
      width: 70px !important;
    }
  }
  .el-form-item__content {
    margin-left: 75px !important;
    @media screen and (max-width: 767px){
      margin-left: 70px !important;
    }
  }
}
.MBDatepicker {
  width: 140px !important;
  .el-input__inner {
    padding-left: 25px !important;
    padding-right: 15px !important;
  }
}
</style>